export default __webpack_public_path__ + "static/media/bidayuh_description.7c209883.png";